import {FC, ReactNode} from "react";
import {css, cx} from "@pandacss/css";

interface Props {
    open?: boolean;
    children: ReactNode
}

const sideMenuClass = css({
    position: "fixed",
    top: 0,
    right: '-300px',
    width: '300px',
    height: '100svh',
    background: 'neutral.800',
    padding: '20px',
    transition: 'right 0.2s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    gap: '48px',
    borderLeft: '1px solid',
    borderColor: 'neutral.500',
    zIndex: 1000,

    '&.open': {
        right: 0
    }
})

const SideMenu: FC<Props> = ({open, children}) => {
    return <div className={cx(sideMenuClass, open ? 'open' : '')}>{children}</div>
}

export default SideMenu